var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonOpenSearchService32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-Elasticsearch-Service_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-Elasticsearch-Service_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Analytics",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23,26 C20.794,26 19,24.206 19,22 C19,19.794 20.794,18 23,18 C25.206,18 27,19.794 27,22 C27,24.206 25.206,26 23,26 L23,26 Z M23,17 C20.243,17 18,19.243 18,22 C18,24.757 20.243,27 23,27 C25.757,27 28,24.757 28,22 C28,19.243 25.757,17 23,17 L23,17 Z M32.284,30.308 C31.974,30.652 31.438,30.68 31.093,30.371 L27.624,27.241 C28.046,26.869 28.424,26.449 28.746,25.986 L32.221,29.116 C32.565,29.428 32.594,29.963 32.284,30.308 L32.284,30.308 Z M17,22 C17,18.691 19.691,16 23,16 C26.309,16 29,18.691 29,22 C29,25.309 26.309,28 23,28 C19.691,28 17,25.309 17,22 L17,22 Z M29.264,25.106 C29.73,24.168 30,23.116 30,22 C30,18.14 26.859,15 23,15 C19.141,15 16,18.14 16,22 C16,25.86 19.141,29 23,29 C24.408,29 25.718,28.578 26.817,27.86 L30.424,31.114 C30.775,31.43 31.216,31.585 31.656,31.585 C32.16,31.585 32.663,31.38 33.027,30.977 C33.705,30.223 33.644,29.055 32.892,28.374 L29.264,25.106 Z M34,9.5 L34,26 L33,26 L33,10 L29,10 L29,15 L28,15 L28,9.5 C28,9.224 28.224,9 28.5,9 L33.5,9 C33.776,9 34,9.224 34,9.5 L34,9.5 Z M26,32 L27,32 L27,33.5 C27,33.776 26.776,34 26.5,34 L21.5,34 C21.224,34 21,33.776 21,33.5 L21,31 L22,31 L22,33 L26,33 L26,32 Z M22,13 L21,13 L21,6.5 C21,6.224 21.224,6 21.5,6 L26.5,6 C26.776,6 27,6.224 27,6.5 L27,13 L26,13 L26,7 L22,7 L22,13 Z M19,30 L20,30 L20,33.5 C20,33.776 19.776,34 19.5,34 L14.5,34 C14.224,34 14,33.776 14,33.5 L14,26 L15,26 L15,33 L19,33 L19,30 Z M15,16 L14,16 L14,10.5 C14,10.224 14.224,10 14.5,10 L19.5,10 C19.776,10 20,10.224 20,10.5 L20,13 L19,13 L19,11 L15,11 L15,16 Z M8,33 L12,33 L12,16 L8,16 L8,33 Z M12.5,15 L7.5,15 C7.224,15 7,15.224 7,15.5 L7,33.5 C7,33.776 7.224,34 7.5,34 L12.5,34 C12.776,34 13,33.776 13,33.5 L13,15.5 C13,15.224 12.776,15 12.5,15 L12.5,15 Z",
    id: "Amazon-Elasticsearch-Service_Icon_32_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonOpenSearchService32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-OpenSearch-Service_32.6944ccd35fcd461666a2dc878b7ed4cb.svg";
export { ForwardRef as ReactComponent };